import { action } from 'easy-peasy';
import { IActionRestoreProgramAssistant } from '../types';

const restoreProgramAssistant: IActionRestoreProgramAssistant = action(
  (state, programAssistantId) => {
    const updatedList = state.list.map(item =>
      item.id !== programAssistantId ? item : { ...item, status: 'Active' },
    );

    state.list = updatedList;
  },
);

export default restoreProgramAssistant;
